import { type FC } from 'react';

import { NotClearedBadge } from '@/src/components/atoms/NotClearedBadge';
import { EvaluatorNotClearedTooltip } from '@/src/components/atoms/NotClearedTooltip/EvaluatorNotClearedTooltip';

export interface EvaluatorNotClearedBadgeProps {
  readonly evaluatorFirstName: string;
  readonly isCurrentUser: boolean;
}

export const EvaluatorNotClearedBadge: FC<EvaluatorNotClearedBadgeProps> = ({
  evaluatorFirstName,
  isCurrentUser,
}) => (
  <EvaluatorNotClearedTooltip evaluatorFirstName={evaluatorFirstName} isCurrentUser={isCurrentUser}>
    <NotClearedBadge />
  </EvaluatorNotClearedTooltip>
);
